import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function ConfirmationModal({ show, handleConfirm, handleCancel, title, message }) {
  return (
    <Modal show={show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || 'تایید عملیات'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || 'آیا مطمئن هستید که می‌خواهید این عملیات را انجام دهید؟'}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          انصراف
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          تایید
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;
